import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const paymentsSettingsRoutes: PermissionedRouteObject = {
  handle: {
    breadcrumb: "Payments",
    breadcrumbNavigate: false,
    permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
  },
  path: "payments",
  children: [
    {
      path: "hsa",
      handle: {
        breadcrumb: "HSA/FSA",
        permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
      },
      lazy: async () => {
        const { HsaSettingsPage } =
          await import("../../../../setting/conversion/hsa/hsa-settings-page");
        return { Component: HsaSettingsPage };
      },
    },
  ],
};
